import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {setTimerShowPopup, setTimerRunning, setTimerTime, onTimerClickDone} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].type,
    running: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].running,
    time: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].time,
    showPopup: state.notebook.protocolSection.scene.apparatus.timers[ownProps.id-1].showPopup
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setShowPopup: (data)=>{
      dispatch(setTimerShowPopup(data))
    },
    setRunning: (data)=>{
      dispatch(setTimerRunning(data))
    },
    setTime: (data)=>{
      dispatch(setTimerTime(data))
    },
    onClickDone: (data)=>{
      dispatch(onTimerClickDone(data))
    },
};
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
